
import { useToast } from "vue-toastification";
import { defineComponent, ref } from "@vue/runtime-core";

import router from "@/router";
import { authService } from "../services/auth";
import { toastError } from "../utils/toastError";

export default defineComponent({
  name: "Signup",
  props: {
    isLogin: Boolean,
  },
  setup() {
    const loading = ref<boolean>(false);
    const toast = useToast();
    return { toast, loading };
  },
  data() {
    return {
      name: "",
      email: "",
      password: "",
    };
  },
  methods: {
    onSubmit(e: Event) {
      e.preventDefault();
      if (this.isLogin) {
        this.loading = true;
        authService
          .login({
            email: this.email,
            password: this.password,
          })
          .then((response) => {
            this.loading = false;
            this.toast.success(response.message);
            localStorage.setItem("token", response.data.accessToken);
            localStorage.setItem("refreshToken", response.data.refreshToken);
            localStorage.setItem("user", JSON.stringify(response.data.user));
            setTimeout(() => router.push("/dashboard"), 1000);
          })
          .catch((err) => {
            this.loading = false;
            toastError(err);
          });
      } else {
        this.loading = true;
        authService
          .signup({
            name: this.name,
            email: this.email,
            password: this.password,
          })
          .then((response) => {
            this.loading = false;
            this.toast.success(response.message);
            setTimeout(() => router.push("/"), 1000);
          })
          .catch((err) => {
            this.loading = false;
            toastError(err);
          });
      }
    },
  },
  inheritAttrs: false, // disable 'non-props' warning
});
